/**
 * 站点跳转地址统一配置
 * 修改此文件即可切换测试/生产环境地址，无需改动业务代码
 */

// 根据域名环境判断
const hostname = window.location.hostname;

// 是否为开发环境（本地 localhost）
const isLocalDev = hostname === 'localhost' || hostname === '127.0.0.1';
// 是否为内网服务器 106
const isServer106 = hostname === '192.168.2.5';
// 是否为内网服务器 200
const isServer200 = hostname === '192.168.2.200';
// 是否正式站点（www / cu / co 以及裸域 teguitong.com）
// 环境判定只认这一个正向特征：换 IP、用机器名或临时端口访问的部署一律按内网处理。
// 反向判断（三个已知 host 都不中就当生产）会让未知 host 拿到 domain=.teguitong.com 的 cookie——
// 浏览器直接静默拒写，而登录态以 cookie 为唯一权威，结果是「刚登录就被判未登录」
const isProdSite = /(^|\.)teguitong\.com$/i.test(hostname);

// 本地开发环境地址
const DEV_URLS = {
	MAIN: 'http://localhost:8080',        // 总入口（主域名）
	PERSON: 'http://localhost:8081',       // 个人版（子域名）
	COMPANY: 'http://localhost:8082',      // 企业版（子域名）
};

// 内网 2.5 服务器地址
const SERVER_106_URLS = {
	MAIN: 'http://192.168.2.5:8080',    // 总入口（主域名）
	PERSON: 'http://192.168.2.5:8081',   // 个人版（子域名）
	COMPANY: 'http://192.168.2.5:8082',  // 企业版（子域名）
};

// 内网 200 服务器地址
const SERVER_200_URLS = {
	MAIN: 'http://192.168.2.200:8700', // 总入口（主域名）
	PERSON: 'http://192.168.2.200:85', // 个人版（子域名）
	COMPANY: 'http://192.168.2.200:86' // 企业版（子域名）
};

// 生产环境地址
const PROD_URLS = {
	MAIN: 'https://www.teguitong.com',     // 总入口（主域名）
	PERSON: 'https://cu.teguitong.com', // 个人版（子域名）
	COMPANY: 'https://co.teguitong.com',    // 企业版（子域名）
};

// 表内未列出的 host（换 IP、机器名、临时端口部署）：本站直接用当前 origin，其余按 8080/8081/8082 约定推。
// 宁可指向同机部署，也绝不能指向线上域名——内网 token 会被 ?tk= 参数明晃晃地带进生产站
const SAME_HOST_URLS = {
	MAIN: `${window.location.protocol}//${window.location.host}`, // 当前就是总入口
	PERSON: `${window.location.protocol}//${hostname}:8081`,
	COMPANY: `${window.location.protocol}//${hostname}:8082`,
};

// 根据环境自动切换
const URLS = isLocalDev ? DEV_URLS
	: isServer106 ? SERVER_106_URLS
	: isServer200 ? SERVER_200_URLS
	: isProdSite ? PROD_URLS
	: SAME_HOST_URLS;

export const SITE_URL = {
	MAIN: URLS.MAIN,
	PERSON: URLS.PERSON,
	COMPANY: URLS.COMPANY,
};

// Cookie 共享域名：生产环境写 .teguitong.com 跨子域共享登录状态；内网各 host 留空，
// 此时写 host-only cookie —— cookie 的作用域不含端口，同 host 的 8080/8081/8082 依然共享
export const COOKIE_DOMAIN = isProdSite ? '.teguitong.com' : '';

// ========== 智能工具：合规审查系统 ==========
// 本地开发 / 内网 2.5 / 内网 200 统一指向内网测试部署，生产环境走正式域名
export const COMPLIANCE_URL = isProdSite ? 'https://compliance.teguitong.com' : 'http://192.168.2.200:8088';

// ========== 智能工具：鉴定评审智能辅助系统 ==========
// 仅生产环境部署（review_co 正式域名）：本地开发 / 内网 2.5 / 内网 200 均无此系统，点击提示「当前环境不支持」
export const IS_PROD_SITE = isProdSite;
export const REVIEW_URL = 'https://review_co.teguitong.com/login';

// “登录后进入鉴定评审智能辅助系统”待办标记（与合规系统同机制，独立 key 与 URL 参数 pr）
// 权限判定同样收口在总入口（见 @/utils/complianceEntry 的 goLoginRedirect）：企业账号旗舰版且主账号/购买账号，
// 有权限就把鉴定评审开在新标签；无权限或判定失败时标记随 getRedirectUrl 转为 URL 参数 pr 交给子站提示/重判。
// TTL 与 pc 同一套约定（5 分钟）
const PENDING_REVIEW_KEY = 'pendingReviewOpen';
export const PENDING_REVIEW_PARAM = 'pr';

// 点击鉴定评审入口时打标（未登录场景）
export function markPendingReview() {
	try {
		sessionStorage.setItem(PENDING_REVIEW_KEY, String(Date.now()));
	} catch (e) {
		/* sessionStorage 不可用时忽略 */
	}
}

// 是否存在待办标记（由 complianceEntry 判定权限时读取；getRedirectUrl 出口消费并转为 URL 凭证交给子站）
export function hasPendingReview() {
	try {
		const nonce = sessionStorage.getItem(PENDING_REVIEW_KEY);
		if (!nonce) return false;
		// 凭证即打标时间戳
		return Date.now() - Number(nonce) < PENDING_COMPLIANCE_TTL;
	} catch (e) {
		return false;
	}
}

// 读取本次待办标记的一次性凭证
export function getPendingReviewNonce() {
	try {
		return sessionStorage.getItem(PENDING_REVIEW_KEY) || '';
	} catch (e) {
		return '';
	}
}

// 清除本站待办标记
export function clearPendingReview() {
	try {
		sessionStorage.removeItem(PENDING_REVIEW_KEY);
	} catch (e) {
		/* ignore */
	}
}

/**
 * 合规系统带 token 的访问地址
 * @param {string} token - 登录 token
 * @returns {string}
 */
export function getComplianceUrl(token) {
	return `${COMPLIANCE_URL}/?token=${encodeURIComponent(token)}`;
}

// “登录后进入合规审查系统”待办标记
// 权限判定已收口在总入口（见 @/utils/complianceEntry 的 goLoginRedirect）：有权限就把合规系统开在新标签。
// 仍保留本标记的两个用途：1）判定为无权限时，随 getRedirectUrl 转为 URL 参数 pc 交给子站弹出“仅支持 VIP/旗舰版”提示
// （在总入口弹提示会被紧随其后的跳转冲掉）；2）总入口判定失败（接口异常）时，由子站守卫用最新信息重判。
// sessionStorage 仅在总入口本站内有效（同标签页同源），跨站靠 pc 参数传递；
// 标记值为一次性凭证（时间戳）：子站据此区分“新跳转”与“刷新/后退”，同一凭证只处理一次
const PENDING_COMPLIANCE_KEY = 'pendingComplianceOpen';
export const PENDING_COMPLIANCE_PARAM = 'pc';

// 点击智能工具入口时打标（未登录场景）
export function markPendingCompliance() {
	try {
		sessionStorage.setItem(PENDING_COMPLIANCE_KEY, String(Date.now()));
	} catch (e) {
		/* sessionStorage 不可用时忽略 */
	}
}

// 待办标记有效期（毫秒）：超时作废，避免用户取消登录后很久才登录被突然跳转
const PENDING_COMPLIANCE_TTL = 5 * 60 * 1000;

// 是否存在待办标记（由 complianceEntry 判定权限时读取；getRedirectUrl 出口消费并转为 URL 凭证交给子站）
export function hasPendingCompliance() {
	try {
		const nonce = sessionStorage.getItem(PENDING_COMPLIANCE_KEY);
		if (!nonce) return false;
		// 凭证即打标时间戳
		return Date.now() - Number(nonce) < PENDING_COMPLIANCE_TTL;
	} catch (e) {
		return false;
	}
}

// 读取本次待办标记的一次性凭证
export function getPendingComplianceNonce() {
	try {
		return sessionStorage.getItem(PENDING_COMPLIANCE_KEY) || '';
	} catch (e) {
		return '';
	}
}

// 清除本站待办标记
export function clearPendingCompliance() {
	try {
		sessionStorage.removeItem(PENDING_COMPLIANCE_KEY);
	} catch (e) {
		/* ignore */
	}
}

// 登录类型标识
export const LOGIN_TYPE_KEY = 'loginType';
export const LOGIN_TYPE_PERSONAL = 'personal';
export const LOGIN_TYPE_ENTERPRISE = 'enterprise';

/**
 * 构建跳转 URL（开发环境额外附加 token / cinfo 参数作兜底：cookie 同 host 已可跨端口共享，
 * 但 localStorage 按端口隔离且浏览器可能禁用 cookie；
 * 生产环境通过 .teguitong.com 域名共享 cookie，无需 URL 传参）
 * @param {string} targetUrl - 目标站点 URL
 * @param {string} token - 登录 token
 * @param {object} [cinfo] - 可选，企业信息对象（与 token 一致：生产环境走 cookie，开发环境走 URL 参数）
 * @returns {string}
 */
export function getRedirectUrl(targetUrl, token, cinfo) {
	// 离开站点的统一出口：若智能工具点击留有“待打开合规系统”标记（总入口判定为无权限或判定失败时才会残留），
	// 通过 URL 参数携带一次性凭证到目标子站（sessionStorage 跨站不共享），由子站守卫提示或用最新信息重判
	const params = [];
	if (hasPendingCompliance()) {
		params.push(`${PENDING_COMPLIANCE_PARAM}=${getPendingComplianceNonce()}`);
		clearPendingCompliance();
	}
	// 鉴定评审同机制：判定未通过或占位标签预开被拦时标记残留，转 pr 凭证交给子站提示/重判
	if (hasPendingReview()) {
		params.push(`${PENDING_REVIEW_PARAM}=${getPendingReviewNonce()}`);
		clearPendingReview();
	}
	if (!COOKIE_DOMAIN && token) {
		params.push(`tk=${encodeURIComponent(token)}`);
	}
	if (!COOKIE_DOMAIN && cinfo) {
		params.push(`cinfo=${encodeURIComponent(JSON.stringify(cinfo))}`);
	}
	if (params.length > 0) {
		const sep = targetUrl.includes('?') ? '&' : '?';
		return `${targetUrl}${sep}${params.join('&')}`;
	}
	return targetUrl;
}

export default SITE_URL;
